import * as ReactIcons from "react-icons/bs";
import * as ReactIconsFa from "react-icons/fa6";
import * as ReactIconsMd from "react-icons/md";
import * as ReactIconsGi from "react-icons/gi";
import * as ReactIconsTb from "react-icons/tb";
import * as ReactIconsPi from "react-icons/pi";

export const ReactIconsCombo = {
  ...ReactIcons,
  ...ReactIconsFa,
  ...ReactIconsMd,
  ...ReactIconsGi,
  ...ReactIconsTb,
  ...ReactIconsPi,
};


